import { APIClient } from '@frontend/api-utils';
import { IUser, UpdateUserState, UserStateTrigger } from '@frontend/user/types';

export class UserWorkflowClient extends APIClient {
    public static readonly endpoint = '/user-api/v1';

    public static async updateUserState(accountId: string, userId: string, userState: UpdateUserState): Promise<IUser> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/users/${userId}/change-state`, userState);
        return await this.handleResponse<IUser>(response);
    }

    public static async postTriggerUserState(accountId: string, userId: string, trigger: UserStateTrigger): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/users/${userId}/trigger`, trigger);
        return await this.handleVoidResponse(response);
    }
}
